import { Switch } from "@mui/material";
import * as React from "react";

export interface CclInfoTableEditSwitchProps {
    value: boolean | null;
    onChange: (newValue: any, required: boolean) => void;
    required: boolean;
    readonly: boolean;
}

const CclInfoTableEditSwitch: React.FC<CclInfoTableEditSwitchProps> = (props) => {
    const [checked, setChecked] = React.useState<boolean>(props?.value ?? false);

    React.useEffect(() => {
        setChecked(props?.value ?? false);
    }, [props.value]);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => {
        setChecked(checked);
        props.onChange(checked, props.required);
    };

    return (
        <Switch
            size="small"
            disabled={props.readonly} 
            checked={checked} 
            onChange={handleChange} 
        />
    );
};

export default CclInfoTableEditSwitch;
